import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=1f8599f8"
import script from "./RegistrationModal.vue?vue&type=script&lang=ts"
export * from "./RegistrationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8599f8')) {
      api.createRecord('1f8599f8', component.options)
    } else {
      api.reload('1f8599f8', component.options)
    }
    module.hot.accept("./RegistrationModal.vue?vue&type=template&id=1f8599f8", function () {
      api.rerender('1f8599f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/RegistrationModal.vue"
export default component.exports